import ru from "./ru.json";
import uz from "./uz.json";

export const LangOptions = [
    'ru',
    'uz'
]

const translations = {
    'ru': ru,
    'uz': uz
}

export const Translate = (lang, key, params = {}) => {
    const langTranslations = translations[lang] || {}
    let translation = langTranslations[key] || key
    const args = params || {}

    const argKeys = Object.keys(args)
    for (let i = 0; i < argKeys.length; i++) {
        const argKey = argKeys[i]
        translation = translation.replace(`{${argKey}}`, args[argKey])
    }

    return translation
}
